var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIclose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4184 0.270992C16.78 -0.0905709 17.3664 -0.0904156 17.728 0.270992C18.0896 0.632598 18.0895 1.21868 17.728 1.58056L10.3091 8.99951L17.728 16.4185C18.0897 16.7801 18.0897 17.3664 17.728 17.728C17.5465 17.9084 17.3095 17.9995 17.0737 17.9995C16.8368 17.9994 16.5997 17.9094 16.4194 17.728L8.99951 10.3081L1.58056 17.728C1.39907 17.9083 1.16212 17.9995 0.925286 17.9995C0.688274 17.9994 0.451064 17.9095 0.270989 17.728C-0.090411 17.3664 -0.0905741 16.78 0.270989 16.4185L7.68993 8.99853L0.270989 1.58056C-0.0903028 1.21866 -0.0905381 0.632519 0.270989 0.270992C0.632517 -0.0905349 1.21866 -0.0903011 1.58056 0.270992L8.99951 7.68994L16.4184 0.270992Z",
    fill: "#0D110F",
    fillOpacity: 0.56
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIclose);
export default __webpack_public_path__ + "static/media/iclose.b9447c786dd2bdfc53acb8e10f37024b.svg";
export { ForwardRef as ReactComponent };